import React, { useState } from 'react';
import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

export function useRenameModel(request, onSaved) {
  const [prediction, setPrediction] = useState(null);
  const [name, setName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const open = row => { setName(row.model_name || ''); setError(''); setPrediction(row); };
  const close = () => { if (!busy) setPrediction(null); };
  const save = async () => {
    if (busy || !prediction || name.trim().length < 2) return;
    setBusy(true); setError('');
    try {
      await request(`/predictions/${prediction.id}/model`, { name });
      setPrediction(null);
      onSaved();
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };
  return { prediction, name, setName, busy, error, open, close, save };
}

export default function RenameModel({ state }) {
  const { prediction, name, setName, busy, error, close, save } = state;
  return <Modal isOpen={!!prediction} toggle={close}><ModalHeader>Rename model</ModalHeader><ModalBody>
    <p className="text-muted">Files this answer under the model that actually gave it. Picks and scores are unchanged. Current name: {prediction?.model_name}</p>
    <input className="form-control" aria-label="Model name" value={name} maxLength={120} autoFocus disabled={busy} onChange={e => setName(e.target.value)} onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); save(); } }} placeholder="e.g. DeepSeek"/>
    {error && <Alert color="danger" fade={false} className="mt-3 mb-0">{error}</Alert>}
  </ModalBody><ModalFooter><Button color="light" disabled={busy} onClick={close}>Cancel</Button><Button color="primary" disabled={busy || name.trim().length < 2} onClick={save}>{busy ? 'Saving…' : 'Save name'}</Button></ModalFooter></Modal>;
}
